import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import YogurtProduct from 'models/YogurtProduct'
import React, { useContext, useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import {
  packagingInitialState,
  fatLevelOptions,
  flavorOptions,
} from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import Switch from 'react-switch'
import Select from 'react-select'
import { isNotAlpha } from 'context/Utilities'

const YogurtPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const { onChange, setSelect, setSwitch, asterisk } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      fatLevelOptions
        .map(({ subCategory }) => subCategory)
        .includes(current?.subCategory)
    ) {
      const {
        category,
        subCategory,
        FatLevel,
        Flavor,
        OtherFlavor,
        Size,
        MultiPackageType,
        MultiPackageCount,
      } = current
      setPackaging({
        category,
        subCategory,
        FatLevel: {
          value: FatLevel || '',
          label: FatLevel.length > 0 ? FatLevel : 'Fat Level',
        },
        Flavor: {
          value: Flavor || '',
          label: Flavor.length > 0 ? Flavor : 'Flavor',
        },
        OtherFlavor,
        Size,
        MultiPackageType: MultiPackageType ?? false,
        MultiPackageCount,
      })
    } else if (!updating) {
      setCurrent(YogurtProduct)
      setPackaging(packagingInitialState)
    }
    console.log(current)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  useEffect(() => {
    if (updating) {
      if (current?.MultiPackageType) {
        methods.setValue('MultiPackageCount', current.MultiPackageCount)
      }
      if (current?.Flavor === 'Other Fruit Flavor') {
        methods.setValue('OtherFlavor', current.OtherFlavor)
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updating])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Fat Level {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            name="FatLevel"
            placeholder={'Select Yogurt Fat Level'}
            options={fatLevelOptions}
            onChange={([selected]) => {
              setSelect(selected, 'FatLevel')
              return selected
            }}
            control={methods.control}
            rules={{ required: true }}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="FatLevel"
              message={'⚠ Please select a Fat Level.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
        <br />
        <FormGroup>
          <p>
            <strong>Flavor {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            name="Flavor"
            placeholder={'Select Flavor'}
            options={flavorOptions}
            onChange={([selected]) => {
              setSelect(selected, 'Flavor')
              return selected
            }}
            control={methods.control}
            rules={{ required: true }}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Flavor"
              message={'⚠ Please select a flavor.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
        <br />
        {current?.Flavor === 'Other Fruit Flavor' && (
          <FormGroup>
            <p>
              <strong>Other Fruit Flavor (Please Specify) {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="OtherFlavor"
              placeholder={'Other Fruit Flavor'}
              control={methods.control}
              rules={{
                required: true,
                maxLength: {
                  value: 30,
                  message: '⚠ Other Fruit Flavor exceeds 30 characters.',
                },
              }}
              onKeyDown={e => {
                if (isNotAlpha(e.key) && e.key !== ' ') {
                  e.preventDefault()
                }
              }}
              onChange={([event]) => {
                onChange(event)
                return event
              }}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="OtherFlavor"
                message={'Other Fruit Flavor is required.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        )}
        <br />
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Input defaultValue={packaging.Size} disabled />
        </FormGroup>
      </Col>
      <Col xs={6}>
        <p>
          <strong>Multi-pack</strong>
        </p>
        <Controller
          as={Switch}
          name="MultiPackageType"
          id="MultiPackageType"
          onChange={([checked, event, id]) => {
            setSwitch(checked, event, id)
            return checked
          }}
          control={methods.control}
          defaultValue={packaging.MultiPackageType}
        />
        <br />
        <br />
        <br />
        {current?.MultiPackageType === true && (
          <FormGroup>
            <p>
              <strong>Multi-pack Count {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="MultiPackageCount"
              placeholder={'Multi-pack Count'}
              onKeyDown={e => {
                if (
                  ![
                    'Backspace',
                    'Delete',
                    'Tab',
                    'ArrowLeft',
                    'ArrowRight',
                  ].includes(e.key) &&
                  isNaN(parseInt(e.key))
                ) {
                  e.preventDefault()
                }
              }}
              control={methods.control}
              rules={{
                maxLength: { value: 2, message: '⚠ 2 characters max.' },
                required: {
                  value: true,
                  message: '⚠ Multi Pack Count is required.',
                },
              }}
              onChange={([event]) => {
                onChange(event)
                return event
              }}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="MultiPackageCount"
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        )}
      </Col>
    </Row>
  )
}

export default YogurtPackage
